module.exports = __webpack_public_path__ + "media/images/swifticons/party-horn-efce5d89a78f86d47481212e1c84ecb7.svg";